import { render, staticRenderFns } from "./home-br.vue?vue&type=template&id=0bc55dda&scoped=true"
import script from "./home-br.vue?vue&type=script&lang=js"
export * from "./home-br.vue?vue&type=script&lang=js"
import style0 from "./home-br.vue?vue&type=style&index=0&id=0bc55dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc55dda",
  null
  
)

export default component.exports